import { render, staticRenderFns } from "./CustomerNotesModal.vue?vue&type=template&id=903c3f1c"
import script from "./CustomerNotesModal.vue?vue&type=script&lang=js"
export * from "./CustomerNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports